module.exports = __webpack_public_path__ + "img/gsb29.dc6ab572.png";